import Axios from 'axios';

Axios.defaults.baseURL = process.env.REACT_APP_URL + '/api/';

window.axios = Axios;
